// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar___X9W8"};